export default "__VITE_ASSET__4c6df4af__"